import { Input, Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'code-input',
    template: require('./code-input.component.html'),
    styles: [require('./code-input.component.css')]
})
export class CodeInputComponent implements OnInit {

    private code: string = "     ";
   
    @ViewChild('c1', { static: false }) c1Element: ElementRef;
    @ViewChild('c2', { static: false }) c2Element: ElementRef;
    @ViewChild('c3', { static: false }) c3Element: ElementRef;
    @ViewChild('c4', { static: false }) c4Element: ElementRef;
    @ViewChild('c5', { static: false }) c5Element: ElementRef;

    @Output() onChanged = new EventEmitter<string>();
    @Output() onEnter = new EventEmitter<void>();

    ngOnInit(): void {
    }

    private replaceAt = (str: string, index: number, replacement: string) => {
        return str.substr(0, index) + replacement + str.substr(index + replacement.length);
    };

    onKeyDown(event: any, input: number): void {
        console.log(event, event.keyCode, event.keyIdentifier, input);
        console.log(event.keyCode.toString());
        if (event.key != "Enter" && event.key != "Backspace" && event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "1" && event.key != "2" && event.key != "3"
            && event.key != "4" && event.key != "5" && event.key != "6" && event.key != "7"
            && event.key != "8" && event.key != "9" && event.key != "0") {
            event.preventDefault();
            return;
        }
        if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Enter")
            this.code = this.replaceAt(this.code, input - 1, (event.key == "Backspace" ? " " : event.key));
        /*this.code = (this.c1Element.nativeElement.value.length == 0 ? " " : this.c1Element.nativeElement.value.length) +
            (this.c2Element.nativeElement.value.length == 0 ? " " : this.c2Element.nativeElement.value.length) +
            (this.c3Element.nativeElement.value.length == 0 ? " " : this.c3Element.nativeElement.value.length) +
            (this.c4Element.nativeElement.value.length == 0 ? " " : this.c4Element.nativeElement.value.length) +
            (this.c5Element.nativeElement.value.length == 0 ? " " : this.c5Element.nativeElement.value.length);*/
        if (event.key != "Backspace" && event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Enter") {
            switch (input) {
                case 1:
                    this.c1Element.nativeElement.value = "";
                break;
                case 2:
                    this.c2Element.nativeElement.value = "";
                    break;
                case 3:
                    this.c3Element.nativeElement.value = "";
                    break;
                case 4:
                    this.c4Element.nativeElement.value = "";
                    break;
                case 5:
                    this.c5Element.nativeElement.value = "";
                    break;
            }
        }
        
        this.change(this.code);

        setTimeout(() => {
            switch(input) {
                case 1:
                    if ((event.key != "Backspace" || event.key == "ArrowRight") && event.key != "ArrowLeft")
                            this.c2Element.nativeElement.focus();
                    break;
                case 2:
                    if (event.key == "Backspace" || event.key == "ArrowLeft")
                        this.c1Element.nativeElement.focus();
                    else
                        this.c3Element.nativeElement.focus();
                    break;
                case 3:
                    if (event.key == "Backspace" || event.key == "ArrowLeft")
                        this.c2Element.nativeElement.focus();
                    else
                        this.c4Element.nativeElement.focus();
                    break;
                case 4:
                    if (event.key == "Backspace" || event.key == "ArrowLeft")
                        this.c3Element.nativeElement.focus();
                    else
                        this.c5Element.nativeElement.focus();
                    break;
                case 5:
                    if (event.key == "Backspace" || event.key == "ArrowLeft")
                        this.c4Element.nativeElement.focus();
                    break;
            }
        }, 10);

        if (event.key == "Enter") {
            this.onEnter.emit();
        }
        
        
    }

    change(code: string) {
        this.onChanged.emit(code);
    }

}